module.exports = __webpack_public_path__ + "static/saffron-e50cc42a54f59021bd9b8d640acd1f1e.svg";